import {Action, ActionReducer, createReducer, MetaReducer, on} from '@ngrx/store';
import {localStorageSync} from 'ngrx-store-localstorage';
import {addFeedItemId, addIdInformation, addIdModalInformation} from './feed.actions';


export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: ['feed'],
    rehydrate: true,
  })(reducer);
}

export const feedMetaReducers: MetaReducer<{feed: FeedState; }, Action> = localStorageSyncReducer;

export interface FeedState {
  idInfos: string[];
  idModalInfos: string[];
  feedItemsId: string[]
}

export const initialFeedStates: FeedState = {
  idInfos: [],
  idModalInfos: [],
  feedItemsId: [],
};

export const feedReducer = createReducer(
  initialFeedStates,

  on(addIdInformation, (state, {id}) => {
    return {
      ...state,
      idInfos: [...state.idInfos, id],
    };
  }),

  on(addIdModalInformation, (state, {id}) => {
    return {
      ...state,
      idModalInfos: [...state.idModalInfos, id],
    };
  }),

  on(addFeedItemId, (state, {id}) => {
    return {
      ...state,
      feedItemsId: [...state.feedItemsId, id],
    };
  }),
);
